import React, { useState, useEffect } from 'react';
import {
  Box, Flex, Grid, FormControl, FormLabel, Input, Textarea,
  NumberInput, NumberInputField, Button, useToast, Text,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { MdSave } from 'react-icons/md';
import { getInstitutionConfig, updateInstitutionConfig } from '../../services/academic.service';

export default function InstitutionConfigView() {
  const toast = useToast();
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  const load = async () => { try { setLoading(true); const r = await getInstitutionConfig(); setConfig(r?.payload || {}); } catch (e) { console.error(e); } finally { setLoading(false); } };

  const handleSave = async () => {
    try {
      setSaving(true);
      await updateInstitutionConfig({
        institutionName: config.institution_name,
        legalName: config.legal_name,
        rut: config.rut,
        address: config.address,
        phone: config.phone,
        email: config.email,
        website: config.website,
        headerText: config.header_text,
        footerText: config.footer_text,
        attendanceMinPercentage: config.attendance_min_percentage,
      });
      toast({ title: 'Configuración guardada', status: 'success', duration: 3000 });
    } catch (e) { toast({ title: 'Error', status: 'error', duration: 3000 }); } finally { setSaving(false); }
  };

  const set = (field, value) => setConfig(prev => ({ ...prev, [field]: value }));

  if (loading) return null;

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Card p={6}>
        <Flex justify="space-between" align="center" mb={6}>
          <Text fontSize="lg" fontWeight="700">Configuración de la Institución</Text>
          <Button leftIcon={<MdSave />} colorScheme="brand" onClick={handleSave}>Guardar</Button>
        </Flex>
        <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={4}>
          <FormControl><FormLabel>Nombre de la Institución</FormLabel><Input value={config.institution_name || ''} onChange={e => set('institution_name', e.target.value)} /></FormControl>
          <FormControl><FormLabel>Razón Social</FormLabel><Input value={config.legal_name || ''} onChange={e => set('legal_name', e.target.value)} /></FormControl>
          <FormControl><FormLabel>RUT</FormLabel><Input value={config.rut || ''} onChange={e => set('rut', e.target.value)} /></FormControl>
          <FormControl><FormLabel>Teléfono</FormLabel><Input value={config.phone || ''} onChange={e => set('phone', e.target.value)} /></FormControl>
          <FormControl><FormLabel>Email</FormLabel><Input type="email" value={config.email || ''} onChange={e => set('email', e.target.value)} /></FormControl>
          <FormControl><FormLabel>Website</FormLabel><Input value={config.website || ''} onChange={e => set('website', e.target.value)} /></FormControl>
          <FormControl gridColumn="span 2"><FormLabel>Dirección</FormLabel><Input value={config.address || ''} onChange={e => set('address', e.target.value)} /></FormControl>
          <FormControl gridColumn="span 2"><FormLabel>Texto Encabezado (para PDFs/certificados)</FormLabel><Textarea value={config.header_text || ''} onChange={e => set('header_text', e.target.value)} rows={2} /></FormControl>
          <FormControl gridColumn="span 2"><FormLabel>Texto Pie de Página</FormLabel><Textarea value={config.footer_text || ''} onChange={e => set('footer_text', e.target.value)} rows={2} /></FormControl>
          <FormControl><FormLabel>% Mínimo de Asistencia</FormLabel><NumberInput min={0} max={100} value={config.attendance_min_percentage || 75} onChange={v => set('attendance_min_percentage', v)}><NumberInputField /></NumberInput></FormControl>
        </Grid>
      </Card>
    </Box>
  );
}
